
import { createContext, useContext, useState, type ReactNode } from "react";

interface SignupWizardState {
  readonly email: string;
  readonly password: string;
  readonly name: string;
  readonly setEmail: (email: string) => void;
  readonly setPassword: (password: string) => void;
  readonly setName: (name: string) => void;
}

const SignupWizardContext = createContext<SignupWizardState | null>(null);

export function SignupWizardProvider({
  children,
  initialEmail = "",
}: {
  readonly children: ReactNode;
  readonly initialEmail?: string;
}) {
  const [email, setEmail] = useState(initialEmail);
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");

  return (
    <SignupWizardContext.Provider value={{ email, password, name, setEmail, setPassword, setName }}>
      {children}
    </SignupWizardContext.Provider>
  );
}

export function useSignupWizard(): SignupWizardState {
  const context = useContext(SignupWizardContext);
  if (!context) {
    throw new Error("useSignupWizard must be used within SignupWizardProvider");
  }
  return context;
}
